export const DIMENSIONS = {
  NAVBAR: {
    mobile: {
      height: 55,
      logoWidth: 70,
    }
  }
};
